const KEY = 'iv1.telemetry.events.v1';

export function loadEvents() {
  try { const raw = localStorage.getItem(KEY); return raw ? JSON.parse(raw) : []; } catch { return []; }
}

export function saveEvents(evts) {
  try { localStorage.setItem(KEY, JSON.stringify(evts)); } catch {}
}

export function logEvent(type, payload={}) {
  const evts = loadEvents();
  evts.push({ ts: Date.now(), type, payload });
  saveEvents(evts);
}

export function initTelemetry() {
  // Global error capture
  if (!window.__TELEM_INIT__) {
    window.__TELEM_INIT__ = true;
    window.addEventListener('error', (e) => {
      try { logEvent('error', { message: e.message, source: e.filename, line: e.lineno, col: e.colno }); } catch {}
    });
    window.addEventListener('unhandledrejection', (e) => {
      try { logEvent('unhandledrejection', { reason: String(e.reason) }); } catch {}
    });
  }
}

export function clearEvents() { try { localStorage.removeItem(KEY); } catch {} }
